import { render, staticRenderFns } from "./TrainerUpdate.vue?vue&type=template&id=3be8530a&"
import script from "./TrainerUpdate.vue?vue&type=script&lang=js&"
export * from "./TrainerUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TrainerUpdate.vue"
export default component.exports